import { useEffect } from "react";
import useHistory from "routing/useHistory";
import workspaceRoutes from "./common/Routes";
const WorkspaceInputConfiguration = ({
  url = workspaceRoutes.INTEGRATIONS.Workspace.ACTIVITYAPI.index
}) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default WorkspaceInputConfiguration;
